<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <h1 class="text-left">Tracker Voltage Over Time for <b v-if="device">{{ device.slno }}</b></h1>
            </v-col>
            <v-col cols="4">
                <v-select v-model="selectedDuration"
                          :items="duration"
                          :loading="processing"
                          label="Select Duration"
                          @update:model-value="fetchVolts"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-progress-circular v-if="processing" color="primary" indeterminate/>
                <canvas ref="voltChart"/>

                <v-btn v-if="chart" class="float-left" color="black" density="compact"
                       variant="outlined" @click="chart.resetZoom()">Reset Zoom
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script setup>
import {ref, onMounted,} from 'vue';
import {useRouter} from "vue-router";
import zoomPlugin from 'chartjs-plugin-zoom';
import {send} from "@/composables/apiClient";
import {Chart, registerables} from 'chart.js';
import {useSnackbarStore} from "@/stores/snackBarStore";

Chart.register(...registerables, zoomPlugin);

const router = useRouter()
const assetId = ref(router.currentRoute.value?.params?.asset ?? null)

const selectedDuration = ref('one_week');
const {showSnackbar} = useSnackbarStore();
const processing = ref(false);
const voltChart = ref(null);
const device = ref(null);
const volts = ref(null);
let chart;
const duration = [
    {
        value: 'one_week',
        title: '1 Week'
    },
    {
        value: 'two_week',
        title: '2 Week'
    },
    {
        value: 'one_month',
        title: '1 Month',
    },
    {
        value: 'two_month',
        title: '2 Month',
    },
    {
        value: 'three_month',
        title: '3 Month',
    },
    {
        value: 'six_month',
        title: '6 Months',
    },
    {
        value: 'one_year',
        title: '1 Year',
    },
    {
        value: 'two_year',
        title: '2 Year',
    },
    {
        value: 'five_year',
        title: '5 Year',
    },
    {
        value: 'all',
        title: 'All'
    },
];
const options = {
    responsive: true,
    interaction: {mode: 'index', intersect: false},
    plugins: {
        legend: {display: true, position: 'top'},
        tooltip: {mode: 'index', intersect: false},
        title: {display: true, text: 'Tracker Voltage Over Time'},
        zoom: {
            /*limits: {
                y: {min: 0, max: 200, minRange: 50}
            },*/
            pan: {
                mode: 'xy',
                enabled: true,
            },
            zoom: {
                wheel: {
                    enabled: true,
                },
                pinch: {
                    enabled: true
                },
                mode: 'xy',
            }
        }
    },
    scales: {
        x: {
            title: {display: true, text: 'Time'},
            ticks: {maxRotation: 45, minRotation: 45}
        },
        y: {
            // beginAtZero: false,
            title: {display: true, text: 'Voltage (V)'},
        }
    }
};

const renderChart = () => {
    if (!volts.value) {
        chart = new Chart(voltChart.value, {
            type: 'line',
            data: {},
            options: options
        });
    }

    const times = volts.value?.map(t => t.event_time);
    const voltages1 = volts.value?.map(t => t.voltage1);
    const voltages2 = volts.value?.map(t => t.voltage2);

    if (chart) {
        chart.destroy();
    }

    chart = new Chart(voltChart.value, {
        type: 'line',
        data: {
            labels: times,
            datasets: [
                {
                    fill: true,
                    data: voltages1,
                    label: 'Voltage 1',
                    borderColor: '#009688',
                    backgroundColor: 'rgb(0,150,136,0.1)',
                },
                {
                    fill: true,
                    data: voltages2,
                    label: 'Voltage 2',
                    borderColor: '#2196F3',
                    backgroundColor: 'rgb(33,150,243,0.1)',
                },
            ],
        },
        options: options
    });
    chart.resetZoom();
}

const fetchVolts = async () => {
    if (!assetId.value)
        return
    processing.value = true;
    send('get', `assets/${assetId.value}/trips/voltages`, {duration: selectedDuration.value})
        .then((response) => {
            device.value = response.data.data.device;
            volts.value = response.data.data.volts;
            renderChart();
        }).catch((error) => {
        showSnackbar('Trip voltages could not be loaded', 'error')
    }).finally(() => processing.value = false)
}
onMounted(fetchVolts);
</script>

<style scoped>
.main-container {
    height: calc(100vh - 100px) !important;
    overflow-y: hidden;
}
</style>
